
export class PushCommandClient {

    constructor(url, appId, userId) {
        this.registry = new PushCommandSubscriberRegistry();
        if (window.NotificationClient) {
            var pushSettings = {
                url: url,
                appId: appId,
                userId: userId,
                deviceId: Math.random().toString(36).substr(2, 16)
            };
            window.NotificationClient.start(pushSettings, this.registry.onCommandReceived);
        }
    }

    getSubscriberRegistry() {
        return this.registry;
    }

}

export class PushCommandSubscriberRegistry {

    constructor() {
        this.handlers = [];

        this.onCommandReceived = this.onCommandReceived.bind(this);
    }

    registerHandler(handler) {
        if (!this.handlers) {
            this.handlers = [];
        }
        this.handlers.push(handler);
    }

    onCommandReceived(command) {
        if (this.handlers) {
            this.handlers.forEach(handler => {
                if (handler && typeof handler === 'function') {
                    handler(command);
                }
            });
        }
    }
}